export const config = {
  apiUrl: import.meta.env.VITE_API_URL,
  clerkClientKey: import.meta.env.VITE_CLERK_CLIENT_KEY,
  orgOverridesEnabled: import.meta.env.VITE_ORG_OVERRIDES_ENABLED === "true",
  opsPortalUrl: import.meta.env.VITE_OPS_PORTAL_URL,
  primaryOpsOrgId: import.meta.env.VITE_PRIMARY_OPS_ORG_ID,
  version: document.querySelector<HTMLMetaElement>('meta[name="app-version"]')
    ?.content,
};
